import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  LanguageService,
  SiteContextActions,
  SiteContextConfig,
  SiteContextSelectors,
  StateWithSiteContext,
  isNotNullable,
} from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { CountrySelectorService } from 'src/app/customServices/country-selector.service';

@Injectable({
  providedIn: 'root',
})
export class KBLanguageService extends LanguageService {
  countryIsoCode: any;
  fromHeader: boolean = true;
  canLoadCart$ = new BehaviorSubject<boolean>(false);
  platformId = inject(PLATFORM_ID);
  constructor(
    protected override store: Store<StateWithSiteContext>,
    protected override config: SiteContextConfig,
    private countrySelectorService: CountrySelectorService,
  ) {
    super(store, config);
  }

  override setActive(isocode: string): void {
    this.store.pipe(select(SiteContextSelectors.getActiveLanguage), take(1)).subscribe((activeLanguage) => {
      if (activeLanguage !== isocode) {
        this.store.dispatch(new SiteContextActions.SetActiveLanguage(isocode));
        if (!this.countrySelectorService.setAllThree) {
          this.canLoadCart$.next(true);
        }
      }
      if (this.fromHeader == true) {
        this.setNewCountry();
      }
    });
  }

  override getActive(): Observable<string> {
    return this.store.pipe(select(SiteContextSelectors.getActiveLanguage), filter(isNotNullable));
  }

  setLangWithCountry(langCode) {
    this.setActive(langCode);
  }
  setNewCountry() {
    if (isPlatformBrowser(this.platformId)) {
      this.countryIsoCode = window.localStorage.getItem('countryNA');
      if (this.countrySelectorService.setAllThree) {
        this.countrySelectorService
          .getDataForCountry(this.countryIsoCode)
          .pipe(distinctUntilChanged())
          .subscribe((data: any) => {
            this.countrySelectorService.setMediaUrl(data.mediaUrl);
            this.countrySelectorService.setDisplayIsoCode(data.displayIsoCodes);
            this.countrySelectorService.setLangIsoCode(data.langIsoCodes);
            this.canLoadCart$.next(true);
            this.countrySelectorService.setAllThree = false;
          });
      }
      else {
        this.countrySelectorService.setAllThree = false;
      }
    }

  }

  onUserManualSelect(langcode) {
    this.fromHeader = false;
    this.setActive(langcode);
  }
}
